import React, { useEffect } from "react";

function DashBoardStats({options}) {

  const {account, deposit, withdrawal, transactions, dasAccount} = options

 
  return (
    <div className="flex flex-wrap -mx-3">
      <div className="w-full max-w-full px-3 mb-6 sm:w-1/2 sm:flex-none xl:mb-0 xl:w-1/4">
        <div className="relative flex flex-col min-w-0 break-words bg-white shadow-soft-xl rounded-2xl bg-clip-border">
          <div className="flex-auto p-4">
            <div className="flex flex-row -mx-3">
              <div className="flex-none w-2/3 max-w-full px-3">
                <div>
                  <p className="mb-0 font-sans font-semibold leading-normal text-sm">
                    Account Balance
                  </p>
                  <h5 className="mb-0 font-bold">
                    {dasAccount?.balance ? dasAccount?.balance + ' '+ dasAccount?.currency : account ? account[0]?.balance + ' ' + account[0]?.currency : '0'}
                  </h5>
                </div>
              </div>
              <div className="px-3 text-right basis-1/3">
                <div className="inline-block w-12 h-12 text-center rounded-lg bg-gradient-to-tl from-primary to-primary-light">
                  <i className="leading-none fa fa-wallet text-lg relative top-3.5 text-lime-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full max-w-full px-3 mb-6 sm:w-1/2 sm:flex-none xl:mb-0 xl:w-1/4">
        <div className="relative flex flex-col min-w-0 break-words bg-white shadow-soft-xl rounded-2xl bg-clip-border">
          <div className="flex-auto p-4">
            <div className="flex flex-row -mx-3">
              <div className="flex-none w-2/3 max-w-full px-3">
                <div>
                  <p className="mb-0 font-sans font-semibold leading-normal text-sm">
                    Deposits
                  </p>
                  <h5 className="mb-0 font-bold">
                    {deposit?.length}
                    {/* <span className="leading-normal text-lime-500 text-sm font-weight-bolder">
                      +5%
                    </span> */}
                  </h5>
                </div>
              </div>
              <div className="px-3 text-right basis-1/3">
                <div className="inline-block w-12 h-12 text-center rounded-lg bg-gradient-to-tl from-primary to-primary-light">
                  <i className="leading-none fa fa-arrow-down text-lg relative top-3.5 text-lime-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full max-w-full px-3 mb-6 sm:w-1/2 sm:flex-none xl:mb-0 xl:w-1/4">
        <div className="relative flex flex-col min-w-0 break-words bg-white shadow-soft-xl rounded-2xl bg-clip-border">
          <div className="flex-auto p-4">
            <div className="flex flex-row -mx-3">
              <div className="flex-none w-2/3 max-w-full px-3">
                <div>
                  <p className="mb-0 font-sans font-semibold leading-normal text-sm">
                    Withdrawals
                  </p>
                  <h5 className="mb-0 font-bold">
                  {withdrawal?.length}
                    {/* <span className="leading-normal text-sm font-weight-bolder text-red-600">
                      +2%
                    </span> */}
                  </h5>
                </div>
              </div>
              <div className="px-3 text-right basis-1/3">
                <div className="inline-block w-12 h-12 text-center rounded-lg bg-gradient-to-tl from-primary to-primary-light">
                  <i className="leading-none fa fa-arrow-up text-lg relative top-3.5 text-red-600"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full max-w-full px-3 sm:w-1/2 sm:flex-none xl:w-1/4">
        <div className="relative flex flex-col min-w-0 break-words bg-white shadow-soft-xl rounded-2xl bg-clip-border">
          <div className="flex-auto p-4">
            <div className="flex flex-row -mx-3">
              <div className="flex-none w-2/3 max-w-full px-3">
                <div>
                  <p className="mb-0 font-sans font-semibold leading-normal text-sm">
                    Transactions
                  </p>
                  <h5 className="mb-0 font-bold">
                    {transactions?.length}
                    {/* <span className="leading-normal text-sm font-weight-bolder text-lime-500">
                      +8%
                    </span> */}
                  </h5>
                </div>
              </div>
              <div className="px-3 text-right basis-1/3">
                <div className="inline-block w-12 h-12 text-center rounded-lg bg-gradient-to-tl from-primary to-primary-light">
                  <i className="leading-none fa fa-exchange-alt text-lg relative top-3.5 text-lime-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashBoardStats;
